import {FC} from 'react'

import cn from 'classnames/bind'

import ContactContent from 'components/blocks/ContactContent'
import {Col, Row} from 'components/elements/grid'

import s from './TemplateContact.module.scss'
const cx = cn.bind(s)

interface ITemplateContactProps {
	className?: string
}

const TemplateContact: FC<ITemplateContactProps> = ({className}) => {
	return (
		<div className={cx('wrapper', className)}>
			<Row>
				<Col md={{offset: 0, span: 12}} xl={{offset: 2, span: 8}}>
					<ContactContent />
				</Col>
			</Row>
		</div>
	)
}

TemplateContact.displayName = 'TemplateContact'

export default TemplateContact
